import React,{ Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { limpiaCarro, sacaProducto } from '../actions'


class Carro extends Component{
	
	constructor(props) {
    	super(props);
    	this.state = {
        	loading : false
    	}
      this.sacaProducto=this.sacaProducto.bind(this)
      this.limpiaCarro=this.limpiaCarro.bind(this)
      this.enviaPedido=this.enviaPedido.bind(this)
    }

  componentDidMount(){
   /* if(!this.props.usuario.user){
      this.props.history.push("/login")
    }*/
    console.log(this.props.carro)
  }

  componentDidUpdate(prevProps, prevState){

  }
  /*
  OJOOO!!! 
  SI AGREGA DOS TIPOS DEL MISMO PRODUCTO Y BORRA  UN ITEM TIENE QUE RECALCULAR EL PRECIO SEGUN LA CANTIDAD
  POR EL MOMENTO PODRIAMOS DEJAR SOLO EL BOTON DE LIMPIAR CARRO
  */
  sacaProducto(pos){
    console.log(pos)
    this.props.sacaProducto(pos)
  }

  enviaPedido(e){
    console.log()
    this.props.history.push("/enviapedido")
  }

  limpiaCarro(){
    this.props.limpiaCarro()
  }



	render() {  

		/*if(this.state.loading){
			return <div>CARGANDO</div>
		}*/
    var total=0

    const  listaCarro = this.props.carro.map((producto,i)=>{
      total+=parseFloat(producto.cantidad) * parseFloat(producto.precio)
      var txt="DEBE PERSONALIZAR"
      var stl="btn-warning"
      if(producto.hasOwnProperty("custom_objs")){
        txt="MODIFICAR DISEÑO"
        stl="btn-info"
      }
          //<td><button type="button" className="btn btn-info" onClick={(e) => this.sacaProducto(i)}>ELIMINAR</button></td>
      return (
        <tr key={i}>
          <td><Link to={'/producto/'+producto.prod_id}>{ producto.rubro_nombre } { producto.prod_nombre } { producto.nombre }</Link></td>
          <td>{producto.cantidad}</td>
          <td>${(parseFloat(producto.cantidad) * parseFloat(producto.precio)).toFixed(2)}</td>
          { producto.custom==="1" ?
            <td><Link to={"/customizar/"+producto.id} className={"btn "+stl} ><i className="fas fa-pencil-alt" /> {txt}</Link></td>
            :
            <td></td>
          }
        </tr>
      )
    })

    return <section className="row mb-5 sombraHead mt-3 clearfix">
        <div className="col-md-4 mb-3" />

        <div className="col-md-6 mb-3">
          <div>
            <h1 className="display-4">Carro</h1>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Producto</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Precio</th>
                <td />
              </tr>
            </thead>
            <tbody>{listaCarro}</tbody>
            <thead>
              <tr>
                <th scope="col">IVA 21%:</th>
                <th scope="col" />
                <th scope="col">
                  ${((total * 21) / 100).toFixed(2)}
                  .-
                </th>
                <th />
              </tr>
              <tr>
                <th scope="col">Total:</th>
                <th scope="col" />
                <th scope="col">
                  ${(total + (total * 21) / 100).toFixed(2)}
                  .-
                </th>
                <th />
              </tr>
            </thead>
          </table>
          <div>
            <button type="button" className="btn btn-info m-2" onClick={this.limpiaCarro}>
              LIMPIA CARRO
            </button>
            {this.props.usuario.user ? <button onClick={this.enviaPedido} className="btn btn-info m-2">
                CONTINUAR
              </button> : <div>
                Para continuar con el pedido debe registrarse y agregar una direccion de envio. Para registrase haga <Link
                  to={"/registro"}
                >
                  {" "}
                  click aca{" "}
                </Link>
              </div>}
          </div>

          <p className="mt-3">
            SI QUIERE DAR DE BAJA UN PRODUCTO, HAGA CLICK EN LA DESCRIPCION
            DEL MISMO Y PONGA LA CANTIDAD EN CERO
          </p>
        </div>
      </section>;
  }
}

const mapStateToProps = state => {
	return {
    	carro: state.productos.carro,
      usuario: state.usuario
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    limpiaCarro: () => {
      dispatch(limpiaCarro())
    },
    sacaProducto: (pos) => {
      dispatch(sacaProducto(pos))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Carro)




// WEBPACK FOOTER //
// ./src/containers/carro.js